import React, { Component } from 'react';
import '../App.css';

// Custom Components
import AppItem from '../components/AppItem';
import VideoHero from './VideoHero';

// Hero Image
import polka from '../img/polka.png'
import me from '../img/me-min.png'
import hero_video from "../img/hero_video.mp4"


//Brand Images
var bassPro = require('../img/bassPro.png')
var invo = require('../img/invo.png')
var MSU = require('../img/MSU.png')
var midwestern = require('../img/midwestern.png')
var powerShades = require('../img/powerShades.png')


class AppShowcase extends Component {
  render() {
    return (
      <div className='apps-container polka'>
        <div style={{paddingTop: '16px'}}>
            <VideoHero
              homePage={true}
              heroBackground={polka}
              addClass={"no-before"}
              darkArrow={true}
              innherBackgroundColor={"#FFF"}
              video={hero_video}
            />
              <div
                className="bento"
              >
                <AppItem
                  navLink={{pathname: "https://www.linkedin.com/in/dalton-wemer-831a28172"}}
                  addClass={"dalton-tile"}
                  socialCTA={true}
                  external={true}
                  backgroundColor={"#FFF"}
                  profilePic={me}
                  textTile={"I design and build fast, intuitive front-end experiences that users enjoy."}
                  textCopy={ `I am a Front-End Engineer with a passion for building high-performance web and mobile experiences. 
                  Experienced in React, React Native, and rapid prototyping, 
                  with a strong eye for UX and a track record of delivering impactful features across startups and large-scale platforms.`}

                />
                <AppItem
                  navLink={"./basspro"}
                  addClass={"bass-pro-tile"}
                  backgroundColor={"#223529"}
                  imgSrc={bassPro}
                />
    
                <AppItem
                  navLink={"./invo"}
                  addClass={"invo-tile"}
                  backgroundColor={"#337EF2"}
                  imgSrc={invo}
                />
                <AppItem
                  navLink={"./msu"}
                  addClass={" msu-tile"}
                  backgroundColor={"#5A000A"}
                  imgSrc={MSU}
                />
                <AppItem
                  navLink={"./midwestern"}
                  addClass={" midwestern-tile"}
                  backgroundColor={"black"}
                  imgSrc={midwestern}
                />
                <AppItem
                  navLink={"./powershades"}
                  addClass={"ps-tile"}
                  backgroundColor={"#EEE"}
                  imgSrc={powerShades}
                />
              </div>
            
        </div>
    </div>
    );
  }
}

export default AppShowcase;






// WEBPACK FOOTER //
// ./src/components/AppShowcase.js